const badges = document.querySelectorAll<HTMLButtonElement>(".rank-badge");
const selectedName = document.querySelector("#rank-selected-name");
const selectedFloor = document.querySelector("#rank-selected-floor");
badges.forEach((badge, index) => {
  badge.addEventListener("click", () => {
    badges.forEach(item => item.setAttribute("aria-pressed", String(item === badge)));
    if (selectedName) selectedName.textContent = badge.dataset.rankName ?? "";
    const tier = String(index + 1).padStart(2, "0");
    const floor = badge.dataset.rankFloor;
    if (selectedFloor) selectedFloor.textContent = document.documentElement.lang === 'zh-Hans'
      ? `第 ${tier} 阶 · ${floor} 分起`
      : document.documentElement.lang === 'es'
        ? `Nivel ${tier} · Desde ${floor} puntos`
        : `Tier ${tier} · From ${floor} rating`;
  });
});
